import searchIcon from '@iconify-icons/akar-icons/search'
import { useTranslation } from 'react-i18next'
import xIcon from '@iconify-icons/akar-icons/circle-x'
import { InputAdornment, InputProps } from '@material-ui/core'
import { Icon, Input } from './SearchInput.style'

interface SearchInputProps extends Partial<InputProps> {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => any
  value: string
  handleClear: () => any
}

const SearchInput = ({
  handleClear,
  onChange,
  value,
  placeholder,
  ...props
}: SearchInputProps) => {
  const { t } = useTranslation()

  return (
    <Input
      endAdornment={
        value.length ? (
          <InputAdornment position="end" onClick={handleClear}>
            <Icon icon={xIcon} clickable />
          </InputAdornment>
        ) : (
          <InputAdornment position="end">
            <Icon icon={searchIcon} />
          </InputAdornment>
        )
      }
      placeholder={placeholder || t('enterSearchTerm')}
      onChange={onChange}
      value={value}
      {...props}
    />
  )
}

export default SearchInput
